import { setModal, useModal } from '@waitroom/common';
import { ReactElement, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';
import AuthModal from '../../../../auth/components/Modal/Auth/AuthModal';
import FeedbackModal from '../../Modal/Feedback/FeedbackModal';
import FreeTrialEndModal from '../../Modal/FreeTrialEnd/FreeTrialEndModal';
import ShareModal from '../../Modal/Share/ShareModal';
import { ModalType } from './types';

const AppModals = (): ReactElement | null => {
  const { pathname } = useLocation();
  const currentModal = useModal.use.modal();
  const { type = ModalType.NONE, props } = currentModal || {};
  const onClose = useCallback(() => setModal(), []);

  useEffect(() => {
    if (pathname) setModal();
  }, [pathname]);

  return (
    <>
      <FreeTrialEndModal
        isOpen={type === ModalType.FREE_TRIAL_END}
        onClose={onClose}
        size="xl"
        isCentered
        {...props}
      />
      <ShareModal
        isOpen={type === ModalType.SHARE}
        onClose={onClose}
        size="lg"
        isCentered
        {...props}
      />
      <FeedbackModal isOpen={type === ModalType.FEEDBACK} onClose={onClose} {...props} />
      <AuthModal
        type={type as ModalType}
        isOpen={type === ModalType.AUTH}
        props={props}
        onClose={onClose}
        setModal={setModal}
        closeOnOverlayClick={false}
      />
    </>
  );
};

export default AppModals;
